import React from 'react';
import { IconProps } from './types';

export const DownloadIcon = ({ className, title }: IconProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
    >
      <title>{title}</title>
      <path
        className="cls-1"
        d="M26,19a1,1,0,0,0-1,1v6H5V20a1,1,0,0,0-2,0v8H27V20A1,1,0,0,0,26,19Z"
      />
      <path
        className="cls-1"
        d="M15,22.25l8.7-6.53a1,1,0,1,0-1.2-1.6L16,19V3a1,1,0,0,0-2,0V19L7.7,14.29a1,1,0,0,0-1.2,1.6Z"
      />
    </svg>
  );
};
